<div class="manager-manager">
  <div class="manager-sidenav">
    <div class="nav-holder">
      @for (nav of navObject; track nav.navName; let i = $index) {
        <div [ngClass]="navStyle" (click)="onNavChange(nav)">
          <div class="nav-selector" [ngClass]="nav.selectorStyle"></div>
          <app-button
            class="nav-button"
            [iconLeft]="nav.navLogo"
            (clicked)="onNavChange(nav)"
          ></app-button>
          <div class="nav-name">
            {{ "manager." + nav.navName + ".label" | translate }}
          </div>
        </div>
      }
      @if (isIBMAdmin()) {
        <div [ngClass]="navStyle" (click)="onNavChange(tokenNavObject)">
          <div
            class="nav-selector"
            [ngClass]="tokenNavObject.selectorStyle"
          ></div>
          <app-button
            class="nav-button"
            [iconLeft]="tokenNavObject.navLogo"
            (clicked)="onNavChange(tokenNavObject)"
          ></app-button>
          <div class="nav-name">
            {{ "manager." + tokenNavObject.navName + ".label" | translate }}
          </div>
        </div>
      }
    </div>
  </div>
  @if (selectedNav === "Users") {
    <app-user-manager></app-user-manager>
  }
  @if (selectedNav === "Groups") {
    <app-profile-manager></app-profile-manager>
  }
  @if (selectedNav === "Reference") {
    <app-reference-manager
      [referenceLoading]="referenceLoading"
    ></app-reference-manager>
  }
  @if (selectedNav === "Token" && isIBMAdmin()) {
    <app-device-off-contract-manager></app-device-off-contract-manager>
  }
  @if (selectedNav === "Devices") {
    <app-switch></app-switch>
  }
</div>
